import { JSX, Show, createSignal, onCleanup } from "solid-js";
import styles from "./Tooltip.module.css";

interface TooltipProps {
  content: string;
  placement?: "top" | "bottom" | "left" | "right";
  children: JSX.Element;
  delay?: number;
}

export function Tooltip(props: TooltipProps) {
  const [visible, setVisible] = createSignal(false);
  let timer: ReturnType<typeof setTimeout> | null = null;

  function show() {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => setVisible(true), props.delay ?? 250);
  }

  function hide() {
    if (timer) clearTimeout(timer);
    timer = null;
    setVisible(false);
  }

  onCleanup(() => {
    if (timer) clearTimeout(timer);
  });

  return (
    <span class={styles.wrap} onMouseEnter={show} onMouseLeave={hide} onFocus={show} onBlur={hide}>
      {props.children}
      <Show when={visible()}>
        <span class={`${styles.tip} ${styles[props.placement ?? "top"]}`} role="tooltip">
          {props.content}
        </span>
      </Show>
    </span>
  );
}
